import script from "./PragueGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./PragueGuide.vue?vue&type=script&lang=ts&setup=true"

import "./PragueGuide.vue?vue&type=style&index=0&id=27fb30f1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27fb30f1"]])

export default __exports__